module.exports = __webpack_public_path__ + "static/media/Loading.98649add.gif";